<template>
    <v-autocomplete filled outlined dense label="PAC" hide-details="auto" :items="db.pacs"
        :item-text="displayText" item-value="uuid" v-model="plantilla.refUuid" return-object @change="submit">
        <template v-slot:append-outer class="ma-0">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="info darken-1" size="30" @click="generate"
                        style="cursor: pointer">mdi-file-download-outline</v-icon>
                </template>
                <span>Genera formato de ejemplo con la entidad seleccionada y descarga el
                    fichero</span>
            </v-tooltip>
        </template>
    </v-autocomplete>
</template>

<script>
import moment from 'moment'
import { uuid } from 'vue-uuid';


export default {
    props: {
        plantilla: {
            type: Object,
            default: () => ({})
        },


    },
    data: () => ({
        db: {
            pacs: []
        }
    }),
    methods: {
        displayText(item) {
            return `PAC de la auditoría ${moment(item.auditoria.fecha).format('DD/MM/YYYY')} - ${item.auditoria.cliente.nombreCompleto
                } (${item.auditoria.subalcance.nombre})`
        },
        submit() {
            this.$emit('input', this.plantilla)
        },
        generate() {
            this.$emit('generate')
        },

        async getPACS() {
            if (!this.plantilla.subalcance) return
            let subalcance_uuid = null
            if (typeof this.plantilla.subalcance == 'object')
                subalcance_uuid = this.plantilla.subalcance.uuid
            else subalcance_uuid = this.plantilla.subalcance
            body = {
                subalcance : {
                    uuid: subalcance_uuid
                }
            }
            const xhr = await this.$store.dispatch('auditorias/getPacs', subalcance_uuid)
            this.db.pacs = xhr
        },

        async init() {
            await this.getPACS()
        }
    },

    mounted() {
        this.init()
    }
}
</script>